export default "__VITE_ASSET__FWx2CsWr__"